import { type FC } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { DeviceVariantColorOption } from 'modules/it_management/components/DeviceVariantSelector/types'

export interface DeviceVariantColorProps {
  variant: DeviceVariantColorOption
  value?: string
  onChange: (value: string) => void
}

export const DeviceVariantColor: FC<DeviceVariantColorProps> = ({ variant, value, onChange }) => {
  return (
    <Box flexDirection="column">
      <SectionHeader title={variant.title} description={''} />
      <Box flexDirection="row" gap="s8">
        {variant.variants.map((option) => {
          const isSelected = option.id === value

          return (
            <Box
              width="s40"
              height="s40"
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              flexNoShrink
              border={{
                all: { style: 'solid', width: 's2', color: isSelected ? 'group1' : 'lighter000' },
              }}
              borderRadius={{ all: 'abs100' }}
            >
              <Box
                className="cursor-pointer"
                width="s32"
                height="s32"
                flexNoShrink
                borderRadius={{ all: 'abs100' }}
                style={{ backgroundColor: option.color }}
                onClick={() => onChange(option.id)}
              ></Box>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
